// Country dial codes with expected mobile number length (digits only, excluding country code)
export const COUNTRIES = [
  { code: "IN", dial: "+91", name: "India", flag: "🇮🇳", length: 10 },
  { code: "US", dial: "+1", name: "United States", flag: "🇺🇸", length: 10 },
  { code: "GB", dial: "+44", name: "United Kingdom", flag: "🇬🇧", length: 10 },
  { code: "AE", dial: "+971", name: "United Arab Emirates", flag: "🇦🇪", length: 9 },
  { code: "SG", dial: "+65", name: "Singapore", flag: "🇸🇬", length: 8 },
  { code: "AU", dial: "+61", name: "Australia", flag: "🇦🇺", length: 9 },
  { code: "CA", dial: "+1", name: "Canada", flag: "🇨🇦", length: 10 },
  { code: "DE", dial: "+49", name: "Germany", flag: "🇩🇪", length: 11 },
  { code: "FR", dial: "+33", name: "France", flag: "🇫🇷", length: 9 },
  { code: "NL", dial: "+31", name: "Netherlands", flag: "🇳🇱", length: 9 },
  { code: "SA", dial: "+966", name: "Saudi Arabia", flag: "🇸🇦", length: 9 },
  { code: "QA", dial: "+974", name: "Qatar", flag: "🇶🇦", length: 8 },
  { code: "MY", dial: "+60", name: "Malaysia", flag: "🇲🇾", length: 10 },
  { code: "NZ", dial: "+64", name: "New Zealand", flag: "🇳🇿", length: 9 },
  { code: "ZA", dial: "+27", name: "South Africa", flag: "🇿🇦", length: 9 },
  { code: "JP", dial: "+81", name: "Japan", flag: "🇯🇵", length: 10 },
  { code: "BD", dial: "+880", name: "Bangladesh", flag: "🇧🇩", length: 10 },
  { code: "LK", dial: "+94", name: "Sri Lanka", flag: "🇱🇰", length: 9 },
  { code: "NP", dial: "+977", name: "Nepal", flag: "🇳🇵", length: 10 },
];

export const DEFAULT_COUNTRY_CODE = "IN";
